import {
  FormControl,
  InputLabel,
  Select as MUISelect,
  SelectProps as MUISelectProps,
} from "@mui/material";
import * as React from "react";

type SelectProps = MUISelectProps & {
  label?: string;
  shrink?: boolean;
  labelTestId?: string;
};

const Select = (props: React.PropsWithChildren<SelectProps>) => {
  const {
    label,
    shrink,
    size = "small",
    sx,
    disabled,
    required,
    labelTestId,
    ...other
  } = props;

  return (
    <FormControl size={size} sx={sx} fullWidth disabled={disabled}>
      <InputLabel data-testid={labelTestId} shrink={shrink} required={required}>
        {label}
      </InputLabel>
      <MUISelect label={label} sx={sx} required={required} {...other}>
        {props.children}
      </MUISelect>
    </FormControl>
  );
};

export default Select;
